var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { slot: "pageContent" }, slot: "pageContent" }, [
    _vm.store === 1
      ? _c(
          "div",
          [
            _c(
              "form-accordion",
              {
                attrs: {
                  title: _vm.$t("common.security.pem"),
                  isTitleUpperCase: false,
                },
              },
              [
                _c(
                  "b-row",
                  { staticClass: "d-flex form-group" },
                  [
                    _c(
                      "b-col",
                      { staticClass: "form-group", attrs: { sm: "6" } },
                      [
                        _c("form-write-group-label-input", {
                          attrs: {
                            isMandatory: "",
                            inputLabel: _vm.$t("common.security.name"),
                            placeholderValue: _vm.$t("common.security.name"),
                          },
                          model: {
                            value: _vm.form.name,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "name", $$v)
                            },
                            expression: "form.name",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c("hr", { staticClass: "mx-auto mb-4" }),
            _vm._v(" "),
            _c(
              "form-accordion",
              {
                attrs: {
                  title: _vm.$t("common.security.certificat"),
                  isTitleUpperCase: false,
                },
              },
              [
                _vm.form.stateCertificat === 1
                  ? _c("app-button", {
                      attrs: {
                        text: _vm.$t("common.security.update_certificat"),
                        icon: "fa-light fa-edit",
                        variant: "secondary",
                        "custom-class": "mb-5",
                      },
                      on: { click: _vm.updateCertificat },
                    })
                  : _c("app-button", {
                      attrs: {
                        text: _vm.$t("common.security.cancel_certificat"),
                        icon: "fa-light fa-times",
                        variant: "secondary",
                        "custom-class": "mb-5",
                      },
                      on: { click: _vm.cancelCertificat },
                    }),
                _vm._v(" "),
                _vm.certificateText === "" && _vm.form.stateCertificat === 0
                  ? _c(
                      "b-row",
                      {
                        staticClass:
                          "d-flex justify-content-center align-items-center form-group",
                      },
                      [
                        _c(
                          "b-col",
                          { staticClass: "form-group", attrs: { sm: "6" } },
                          [
                            _c("span", { staticClass: "filter-item-title" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("common.security.certificat_file")
                                )
                              ),
                            ]),
                            _vm._v(" "),
                            _c("span", { staticClass: "color-red" }, [
                              _vm._v("* "),
                            ]),
                            _vm._v(" "),
                            _c("b-form-textarea", {
                              staticStyle: { "max-height": "none" },
                              attrs: {
                                id: "textarea",
                                placeholder: _vm.$t("common.enter_something"),
                                rows: "6",
                              },
                              on: { input: _vm.processCertificat },
                              model: {
                                value: _vm.certificateText,
                                callback: function ($$v) {
                                  _vm.certificateText = $$v
                                },
                                expression: "certificateText",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _vm.certificateText === ""
                          ? _c(
                              "b-col",
                              {
                                staticClass: "form-group d-flex flex-column",
                                attrs: { sm: "6" },
                              },
                              [
                                _c("span", [
                                  _c(
                                    "span",
                                    { staticClass: "filter-item-title" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "common.security.certificat_file"
                                          )
                                        )
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "color-red" }, [
                                    _vm._v("* "),
                                  ]),
                                ]),
                                _vm._v(" "),
                                _c("input", {
                                  attrs: { type: "file", accept: ".pem" },
                                  on: {
                                    change: _vm.handleFileUploadCertificat,
                                  },
                                }),
                              ]
                            )
                          : _vm._e(),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.certificateText !== ""
                  ? _c(
                      "b-row",
                      {
                        staticClass:
                          "d-flex justify-content-center align-items-center form-group",
                      },
                      [
                        _c(
                          "b-col",
                          { staticClass: "form-group", attrs: { sm: "12" } },
                          [
                            _c("span", { staticClass: "filter-item-title" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("common.security.certificat_file")
                                )
                              ),
                            ]),
                            _vm._v(" "),
                            _c("span", { staticClass: "color-red" }, [
                              _vm._v("* "),
                            ]),
                            _vm._v(" "),
                            _c("b-form-textarea", {
                              staticStyle: { "max-height": "none" },
                              attrs: {
                                id: "textarea",
                                placeholder: _vm.$t("common.enter_something"),
                                rows: "6",
                              },
                              on: { input: _vm.processCertificat },
                              model: {
                                value: _vm.certificateText,
                                callback: function ($$v) {
                                  _vm.certificateText = $$v
                                },
                                expression: "certificateText",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _vm.certificateText === ""
                          ? _c(
                              "b-col",
                              {
                                staticClass: "form-group d-flex flex-column",
                                attrs: { sm: "6" },
                              },
                              [
                                _c("span", [
                                  _c(
                                    "span",
                                    { staticClass: "filter-item-title" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "common.security.certificat_file"
                                          )
                                        )
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "color-red" }, [
                                    _vm._v("* "),
                                  ]),
                                ]),
                                _vm._v(" "),
                                _c("input", {
                                  attrs: { type: "file", accept: ".pem" },
                                  on: {
                                    change: _vm.handleFileUploadCertificat,
                                  },
                                }),
                              ]
                            )
                          : _vm._e(),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "b-row",
                  { staticClass: "d-flex align-items-center form-group" },
                  [
                    _c(
                      "b-col",
                      { staticClass: "form-group", attrs: { sm: "6" } },
                      [
                        _c("form-read-group-label-input", {
                          attrs: {
                            inputValue: _vm.form.startDate,
                            inputLabel: _vm.$t("common.security.startDate"),
                            placeholderValue: _vm.$t(
                              "common.security.startDate"
                            ),
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-col",
                      { staticClass: "form-group", attrs: { sm: "6" } },
                      [
                        _c("form-read-group-label-input", {
                          attrs: {
                            inputValue: _vm.form.endDate,
                            inputLabel: _vm.$t("common.security.endDate"),
                            placeholderValue: _vm.$t("common.security.endDate"),
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-row",
                  { staticClass: "d-flex align-items-center form-group" },
                  [
                    _c(
                      "b-col",
                      { staticClass: "form-group", attrs: { sm: "6" } },
                      [
                        _c("form-read-group-label-input", {
                          attrs: {
                            inputValue: _vm.form.deliveredBy,
                            inputLabel: _vm.$t("common.security.deliveredBy"),
                            placeholderValue: _vm.$t(
                              "common.security.deliveredBy"
                            ),
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-col",
                      { staticClass: "form-group", attrs: { sm: "6" } },
                      [
                        _c("form-read-group-label-input", {
                          attrs: {
                            inputValue: _vm.form.deliveredTo,
                            inputLabel: _vm.$t("common.security.deliveredTo"),
                            placeholderValue: _vm.$t(
                              "common.security.deliveredTo"
                            ),
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c("hr", { staticClass: "mx-auto mb-4" }),
            _vm._v(" "),
            _c(
              "form-accordion",
              {
                attrs: {
                  title: _vm.$t("common.security.private_key"),
                  isTitleUpperCase: false,
                },
              },
              [
                _vm.form.statePrivateKey === 1
                  ? _c("app-button", {
                      attrs: {
                        text: _vm.$t("common.security.update_privatekey"),
                        icon: "fa-light fa-edit",
                        variant: "secondary",
                        "custom-class": "mb-5",
                      },
                      on: { click: _vm.updatePrivateKey },
                    })
                  : _c("app-button", {
                      attrs: {
                        text: _vm.$t("common.security.cancel_privatekey"),
                        icon: "fa-light fa-times",
                        variant: "secondary",
                        "custom-class": "mb-5",
                      },
                      on: { click: _vm.cancelPrivateKey },
                    }),
                _vm._v(" "),
                _c(
                  "b-row",
                  {
                    staticClass:
                      "d-flex justify-content-center align-items-center form-group",
                  },
                  [
                    _vm.privateKeyText === "" && _vm.form.statePrivateKey === 0
                      ? _c(
                          "b-col",
                          { staticClass: "form-group", attrs: { sm: "6" } },
                          [
                            _c("span", { staticClass: "filter-item-title" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("common.security.private_key_file")
                                )
                              ),
                            ]),
                            _vm._v(" "),
                            _c("span", { staticClass: "color-red" }, [
                              _vm._v("* "),
                            ]),
                            _vm._v(" "),
                            _c("b-form-textarea", {
                              staticStyle: { "max-height": "none" },
                              attrs: {
                                id: "textarea",
                                placeholder: _vm.$t("common.enter_something"),
                                rows: "6",
                              },
                              on: { input: _vm.processPrivateKey },
                              model: {
                                value: _vm.privateKeyText,
                                callback: function ($$v) {
                                  _vm.privateKeyText = $$v
                                },
                                expression: "privateKeyText",
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.privateKeyText !== "" && _vm.form.statePrivateKey === 0
                      ? _c(
                          "b-col",
                          { staticClass: "form-group", attrs: { sm: "12" } },
                          [
                            _c("span", { staticClass: "filter-item-title" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("common.security.private_key_file")
                                )
                              ),
                            ]),
                            _vm._v(" "),
                            _c("span", { staticClass: "color-red" }, [
                              _vm._v("* "),
                            ]),
                            _vm._v(" "),
                            _c("b-form-textarea", {
                              staticStyle: { "max-height": "none" },
                              attrs: {
                                id: "textarea",
                                placeholder: _vm.$t("common.enter_something"),
                                rows: "6",
                              },
                              on: { input: _vm.processPrivateKey },
                              model: {
                                value: _vm.privateKeyText,
                                callback: function ($$v) {
                                  _vm.privateKeyText = $$v
                                },
                                expression: "privateKeyText",
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.privateKeyText === "" && _vm.form.statePrivateKey === 0
                      ? _c(
                          "b-col",
                          {
                            staticClass: "form-group d-flex flex-column",
                            attrs: { sm: "6" },
                          },
                          [
                            _c("span", [
                              _c("span", { staticClass: "filter-item-title" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("common.security.private_key_file")
                                  )
                                ),
                              ]),
                              _vm._v(" "),
                              _c("span", { staticClass: "color-red" }, [
                                _vm._v("* "),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("input", {
                              attrs: { type: "file", accept: ".key" },
                              on: { change: _vm.handleFileUploadPrivateKey },
                            }),
                          ]
                        )
                      : _vm._e(),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-row",
                  {
                    staticClass:
                      "d-flex justify-content-center align-items-center form-group",
                  },
                  [
                    _c(
                      "b-col",
                      { staticClass: "form-group", attrs: { sm: "6" } },
                      [
                        _c("form-write-group-label-input", {
                          attrs: {
                            inputLabel: _vm.$t("common.security.password"),
                            placeholderValue: _vm.$t(
                              "common.security.password"
                            ),
                          },
                          model: {
                            value: _vm.form.password,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "password", $$v)
                            },
                            expression: "form.password",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("b-col", {
                      staticClass: "form-group",
                      attrs: { sm: "6" },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }